import React from 'react';
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import Badge from "./badge";
import IconPostalUtils from "../images/icon-postal-utils.png";
import IconeCommerce from "../images/icon-ecommerce.png";
import IconEstimate from "../images/icon-estimate.png";
import IconInform247 from "../images/icon-inform247.png";
import IconEmplCompliance from "../images/icon-empl-compliance.png";
import IconEmplUtilization from "../images/icon-empl-utilization.png";
import IconHamburger from "../images/icon-hamburger.svg";
import { useCan } from '../hooks/useCan';
import { PLATFORMADMIN_ROLES } from './navConfig';

export default function AppSwitcherPopover() {
  const canSwitchApps = useCan(PLATFORMADMIN_ROLES);
  if (!canSwitchApps) return null;

  return (
    <Popover className="relative">
      {() => (
        <>
          <PopoverButton
            className="ml-4 flex w-11 h-11 items-center justify-center text-gray-600 hover:cursor-pointer hover:bg-gray-100 focus:bg-gray-100 focus:ring-2 focus:ring-gray-100 rounded focus:outline-none">
            <img src={IconHamburger} className="w-7 h-7" alt="Switch app" />
          </PopoverButton>

          <PopoverPanel className="absolute right-0 z-10 w-screen max-w-sm transform px-4 sm:px-0 lg:max-w-md border b-gray-200">
            <div className="max-w-xl mx-auto bg-white shadow-lg p-3">
              {/* Inform247 app */}
              <a href="http://inform247.io" className="block">
                <div className="flex items-center justify-between group hover:bg-gray-200 p-3 cursor-pointer">
                  <div className="flex items-center gap-4">
                    <div className="flex items-center justify-center transition-all -ml-1">
                      <img src={IconInform247} className="w-[28px]" alt="Inform247 logo" />
                    </div>
                    <div>
                      <h3 className="text-base font-medium leading-none">Inform247</h3>
                      <p className="text-sm text-gray-400">Monitor print jobs</p>
                    </div>
                  </div>
                  <div>
                    {window.location.href.includes("inform247.io") && (<Badge text="Current" />)}
                  </div>
                  </div>
              </a>

              <div className="space-y-4x">
                {/* Postal Utilities app */}
                <a href="http://10.10.10.89:7005" className="block">
                  <div className="flex items-center justify-between group hover:bg-gray-200 py-3 px-2 cursor-pointer">
                    <div className="flex items-center gap-4">
                      <div className="flex items-center justify-center transition-all">
                        <img src={IconPostalUtils} className="w-[28px]" alt="Postal Utils logo" />
                      </div>
                      <div>
                        <h3 className="text-base font-medium leading-none">Postal Utilities</h3>
                        <p className="text-sm text-gray-400">Cleanse mailing addresses</p>
                      </div>
                    </div>
                    <div>
                      {window.location.href.includes("http://10.10.10.89:7005") && (<Badge text="Current" />)}
                    </div>
                  </div>
                </a>

                {/* eCommerce app */}
                <a href="http://10.10.10.89:3001" className="block">
                  <div className="flex items-center justify-between group hover:bg-gray-200 py-3 px-2 cursor-pointer">
                    <div className="flex items-center gap-4">
                      <div className="flex items-center justify-center transition-all">
                        <img src={IconeCommerce} className="w-[28px]" alt="eCommerce logo" />
                      </div>
                      <div>
                        <h3 className="text-base font-medium leading-none">eCommerce</h3>
                        <p className="text-sm text-gray-400">Administer the eCommerce platform</p>
                      </div>
                    </div>
                    <div>
                      {window.location.href.includes("http://10.10.10.89:3001") && (<Badge text="Current" />)}
                    </div>
                  </div>
                </a>

                {/* Estimate app */}
                <a href="http://10.10.10.89:4000/" className="block">
                  <div className="flex items-center justify-between group hover:bg-gray-200 p-3 cursor-pointer">
                    <div className="flex items-center gap-4">
                      <div className="flex items-center justify-center transition-all">
                        <img src={IconEstimate} className="w-[28px]" alt="Estimate logo" />
                      </div>
                      <div>
                        <h3 className="text-base font-medium leading-none">Estimate</h3>
                        <p className="text-sm text-gray-400">Estimate a print job</p>
                      </div>
                    </div>
                    <div>
                      {window.location.href.includes("http://10.10.10.89:4000") && (<Badge text="Current" />)}
                    </div>
                  </div>
                </a>

                {/* Emp Compliance app */}
                <a href="http://inform247.io:81" className="block">
                  <div className="flex items-center justify-between group hover:bg-gray-200 p-3 cursor-pointer">
                    <div className="flex items-center gap-4">
                      <div className="flex items-center justify-center transition-all">
                        <img src={IconEmplCompliance} className="w-[28px]" alt="Employee Compliance logo" />
                      </div>
                      <div>
                        <h3 className="text-base font-medium leading-none">Employee Compliance</h3>
                        <p className="text-sm text-gray-400">Review compliance scans</p>
                      </div>
                    </div>
                    <div>
                      {window.location.href.includes("inform247.io:81") && (<Badge text="Current" />)}
                    </div>
                  </div>
                </a>

                {/* Emp Utilization app */}
                <a href="http://10.10.10.89:2500/" className="block">
                  <div className="flex items-center justify-between group hover:bg-gray-200 p-3 cursor-pointer">
                    <div className="flex items-center gap-4">
                      <div className="flex items-center justify-center transition-all">
                        <img src={IconEmplUtilization} className="w-[28px]" alt="Employee Utilization logo" />
                      </div>
                      <div>
                        <h3 className="text-base font-medium leading-none">Employee Utilization</h3>
                        <p className="text-sm text-gray-400">Review employee utilization data</p>
                      </div>
                    </div>
                    <div>
                      {window.location.href.includes("http://10.10.10.89:2500") && (<Badge text="Current" />)}
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </PopoverPanel>
        </>
      )}
    </Popover>
  );
} 